import React from 'react';
import { useTranslation } from 'react-i18next';
import { Alert } from 'reactstrap';

const MacroInfoPanel = () => {
  const { t } = useTranslation();

  return (
    <Alert color="info" className="mt-3 mb-0">
      <h6 className="font-size-14 mb-2">
        <i className="bx bx-code-alt mr-1" />
        {t('Available macros')}
      </h6>
      <p className="mb-2">
        {t(
          'You can customize the DEM by manually inserting macros related to the lead object.',
        )}
      </p>
      <p className="mb-0">
        {t('Examples')}: <code>{'{{lead.firstName}}'}</code>,{' '}
        <code>{'{{lead.lastName}}'}</code>, <code>{'{{lead.email}}'}</code>.
      </p>
      <p className="mt-3 mb-0">
        {t(
          'Note: macros will only work if the template is sent through our future email sending system.',
        )}
      </p>
    </Alert>
  );
};

export default MacroInfoPanel;
